
function useHandleLogout() {
    localStorage.setItem("loggedUser", JSON.stringify({}));
    window.open("/login", "_self");
};

export default useHandleLogout;